import queryString from "query-string";
import { parseFilter, stringifyFilter } from "./queryUtils";
export function hydrateRoute(routePath, params) {
  const withoutLocale = (routePath || "").replace(/^\/:locale\(.+?\)\?/, "");
  const hydrated = withoutLocale.replace(/:[a-zA-Z]+(\(.+?\))?\??\*?/gi, part => {
    const paramName = part.slice(1).replace(/\(.*?\)\??\*?|\?|\*/, "");
    const defaultValue = part.match(/\?$/) ? "" : part.match(/^:/) ? "" : part;
    return params[paramName] !== undefined ? params[paramName] : defaultValue;
  });
  return (params.locale && hydrated.match(/^\//) ? `/${params.locale}${hydrated}` : hydrated).replace(/\/+/gi, "/");
}
export function createLink(basePath, proxy, item, params, modulePrefix = undefined) {
  if (!(item && item.id && `${item.id}`.length || item && item.to && `${item.to}`.length || item && item.link)) {
    return null;
  }
  if (basePath) {
    return `${hydrateRoute(basePath, {
      ...params
    })}/${item.id}`.replace(/\/\//g, "");
  }
  if (item.to) {
    return hydrateRoute(item.to, {
      ...params
    }).replace(/\/\//g, "");
  }
  if (item.link && item.link.to && item.link.to.length) {
    let filters = item.link.filter || [];
    if (item.link.appendFilters && params.filter) {
      const currentFilter = parseFilter(params.filter).filter(({
        column
      }) => item.link.appendFilters.includes(column));
      filters = [...filters, ...currentFilter];
    }
    const pathname = hydrateRoute(item.link.to, {
      ...params
    }).replace(/\/\//g, "");
    const search = filters && filters.length ? stringifyFilter(filters) : null;
    return `${pathname}${search ? `?filter=${search}` : ""}`;
  }
  if (item && item.entity && item.entity.length) {
    const proxyPathByEntity = (proxy || {})[item["entity"]];
    return hydrateRoute(modulePrefix ? modulePrefix : proxyPathByEntity, {
      ...params,
      id: item.id
    }).replace(/\/\//g, "");
  }
  const proxyPath = (proxy || {})[item["__typename"]];
  return hydrateRoute(modulePrefix ? modulePrefix : proxyPath, {
    ...params,
    id: item.id
  }).replace(/\/\//g, "");
}
function injectFilters(path, queryParams) {
  if (queryParams && !queryParams.filter || !queryParams) {
    return path;
  }
  return `${path}?${queryString.stringify({
    filter: queryParams.filter
  })}`;
}
export function createLinkCard(basePath, proxy, item, params, queryParams) {
  if (!(item && item.id && `${item.id}`.length || item && item.to && `${item.to}`.length)) {
    return null;
  }
  if (basePath) {
    return injectFilters(`${hydrateRoute(basePath, {
      ...params
    })}/${item.id}`, queryParams);
  }
  if (item.to) {
    return injectFilters(hydrateRoute(item.to, {
      ...params
    }), queryParams);
  }
  const proxyPath = (proxy || {})[item["__typename"]];
  return injectFilters(hydrateRoute(proxyPath, {
    ...params,
    id: item.id
  }), queryParams);
}
export function regexURLMatcher(regex, matchRegex) {
  return regex.exec(matchRegex);
}